import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SectionTitle from '@src/components/SectionTitle';
import { InviteCollaborators } from '@src/containers/InviteCollaborators';
import { setModalContent, closeModal } from '@src/redux/actions/modal';
import { idify } from '@src/util/idify';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { trackEvent } from '@src/metrics';
import './styles.scss';

const Collaborators = ({ title, subtitle, buttonLabel, opening, metricsContext, setModalContent, closeModal }) => (
  <div className="collaborators-wrapper">
    <div className="collaborators">
      <SectionTitle subtitle={subtitle} title={title} />

      <button
        className="position-title-input-wrapper"
        onClick={() => {
          setModalContent({
            content: <InviteCollaborators onClose={() => closeModal()} opening={opening} />,
          });

          trackEvent({
            context: MetricContext.INVITING_COLLABORATORS,
            interaction: MetricAction.OPEN_MANAGE_COLLABORATORS,
            payload: {
              'Event Source': MetricEventSource.MANAGE_COLLABORATORS_BUTTON,
              'Opening Id': idify(opening),
              'Previous Context': metricsContext,
            },
          });
        }}
      >
        {buttonLabel}
      </button>
    </div>
  </div>
);

Collaborators.propTypes = {
  buttonLabel: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  metricsContext: PropTypes.oneOf(Object.values(MetricContext)).isRequired,
  opening: PropTypes.object.isRequired,
  setModalContent: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

Collaborators.defaultProps = {
  buttonLabel: 'Invite collaborators',
  opening: PropTypes.object.isRequired,
  subtitle: 'Invite team leads or hiring managers from your company who will have access to this position.',
  title: 'Invite collaborators',
};

export default connect(null, {
  closeModal,
  setModalContent,
})(Collaborators);
